import fordImage from "./images/fordImage.png";
import fordGuestBoard from './images/fordGuestBoard.svg'

const FordImageComponent = (props:any) => {
    const {classes}=props;
    return (
        <img
            className={classes.fordImage}
            alt="Logo"
            src={fordGuestBoard}
        />
    )
}

export default FordImageComponent;